import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react/prop-types */
import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics'; // import PropTypes from 'prop-types';

import useTheme from './useTheme';

function defaultMergeProps(ownProps, variantProps) {
  return _objectSpread(_objectSpread({}, variantProps), ownProps);
}
/**
 * A Higher Order Component (HOC) for retrieving theme values as props. Use this
 * when you create a component that has a dedicated section of the theme
 * supplying its default styling or the styling of multiple variants.
 *
 * Use like:
 *
 * ```js
 * export default withThemeProps(Modal, {
 *   section: 'modal',
 *   defaultVariant: 'default'
 * });
 * ```
 *
 * The resulting component will support an `variant` prop; if not passed
 * explicitly, it will default to the (optional) `defaultVariant`. The `section`
 * and `variant` are passed to the `useTheme` hook; see its documentation for
 * how it works.
 *
 * The resulting theme values are then merged with the component's own props and
 * passed to the component.
 */


export default function withThemeProps(Component) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      section = _ref.section,
      defaultVariant = _ref.defaultVariant,
      _ref$mergeProps = _ref.mergeProps,
      mergeProps = _ref$mergeProps === void 0 ? defaultMergeProps : _ref$mergeProps;

  var name = Component.displayName || Component.name || 'Component';
  var WithThemeProps = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
    var _ref2$variant = _ref2.variant,
        variant = _ref2$variant === void 0 ? defaultVariant : _ref2$variant,
        props = _objectWithoutProperties(_ref2, ["variant"]);

    var variantProps = useTheme(section, variant);
    var mergedProps = mergeProps(props, variantProps);
    return /*#__PURE__*/React.createElement(Component, _extends({
      ref: ref
    }, mergedProps));
  }); // WithThemeProps.propTypes = {
  //   ...Component.propTypes,
  //   variant: PropTypes.string,
  // };
  // WithThemeProps.defaultProps = {
  //   variant: 'defaultVariant',
  // };

  WithThemeProps.displayName = "withThemeProps(".concat(name, ")");
  hoistNonReactStatics(WithThemeProps, Component);
  return WithThemeProps;
}